import Form from '@admin/components/form'
import PropTypes from 'prop-types'
import React from 'react'

class Previews extends React.PureComponent {

  static contextTypes = {
    admin: PropTypes.object
  }

  static propTypes = {
    formdata: PropTypes.object,
    onBack: PropTypes.func,
    onCancel: PropTypes.func,
    onChange: PropTypes.func,
    onNext: PropTypes.func,
    onSave: PropTypes.func
  }

  state = {
    config: {}
  }

  formRef = React.createRef()

  _handleBack = this._handleBack.bind(this)
  _handleChange = this._handleChange.bind(this)
  _handleSubmit = this._handleSubmit.bind(this)
  _handleSuccess = this._handleSuccess.bind(this)

  render() {
    return <Form { ...this._getForm() } />
  }

  _getForm() {
    const { formdata } = this.props
    return {
      ref: this.formRef,
      showHeader: false,
      buttons: [
        { label: 't(Previous)', color: 'blue', basic: true, handler: this._handleBack },
        { label: 't(Finish)', color: 'blue', handler: this._handleSubmit }
      ],
      onChange: this._handleChange,
      onSuccess: this._handleSuccess,
      sections: [
        {
          instructions: 't(When content is published for your advisors, they will be sent email previews. You can customize the preview messages sent for both email and social media content below.)',
          fields: [
            { 
              label: 't(Email Preview Message)', 
              name: 'config.email_preview_message', 
              type: 'htmlfield', 
              required: true ,
              defaultValue: formdata.config?.email_preview_message
            },
            { 
              label: 't(Social Media Preview Message)', 
              name: 'config.social_preview_message', 
              type: 'htmlfield', 
              required: true ,
              defaultValue: formdata.config?.social_preview_message
            }
          ]
        }
      ]
    }
  }

  _handleBack() {
    this.props.onBack()
  }

  _handleChange(config) {
    this.setState({ config })
  }

  _handleSubmit() {
    this.formRef.current.submit()
  }

  _handleSuccess(agency) {
    const { formdata } = this.props
    this.props.onSave({
      config: {
        ...formdata.config,
        ...agency.config
      }
    })
  }

}

export default Previews
